import { render, staticRenderFns } from "./ManagePandect.vue?vue&type=template&id=fff91232"
import script from "./ManagePandect.vue?vue&type=script&lang=js"
export * from "./ManagePandect.vue?vue&type=script&lang=js"
import style0 from "./ManagePandect.vue?vue&type=style&index=0&id=fff91232&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports